import { render } from "./RoleSettingsViewAddEditRoleModal.vue?vue&type=template&id=3bdce330"
import script from "./RoleSettingsViewAddEditRoleModal.vue?vue&type=script&lang=js"
export * from "./RoleSettingsViewAddEditRoleModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__